import { API, requestDeleteWithPayload } from 'api/base';

/**
 * [POST /dev/accounts]
 *
 * { favorite_id: STRING,
 *   player_id: STRING,
 *  }
 *
 * Add a new favorite player
 *
 */

const deleteFavorite = ({ player_id, favorite_id }) => {
  const endpointDomain = process.env.REACT_APP_API_DOMAIN;

  return requestDeleteWithPayload(API(endpointDomain, 'dev/favorite'), {
    player_id,
    favorite_id,
  });
};

export default deleteFavorite;
